import React from "react";
import TopHeader from "../../Components/TopHeader";
import MainHeader from "../../Components/MainHeader";
import BlogSections from "../../Components/BlogSections";
import Footer from "../../Components/Footer";
import "../../Pages/Testominals/testimonial.css";
function Testimonial() {
    return (
        <>
            <TopHeader />
            <MainHeader />
            <div className="main-section set_max_width_banner">
                <div className="container-fluid h-100 text-light ">
                    <div className="row h-100">
                        <div className="col-lg-12 d-flex justify-content-center align-items-center flex-column">
                            <h3>Testimonial - Motor Easy</h3>
                            <p>
                                You Here!&gt; <a href="index.html">Home</a> &gt; Testimonial
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="our-testmonial">
                <div className="container text-center">
                    <div className="text-section mt-4">
                        <h5 className="mt-5">OUR TESTIMONIAL</h5>
                        <h3>
                            Happy Our <span>Client</span>
                        </h3>
                    </div>
                </div>
            </div>
            <div className="container">
    <div className="row">
      {/* ----------- For Large screen --------- */}
      <div
        id="carouselExampleIndicators"
        className="carousel slide d-none d-lg-block"
      >
        <div className="carousel-inner">
          <div className="carousel-item active">
            <div className="row testimonial_carousel">
              <div className="col-lg-6">
                <div className="card">
                  <div className="card-body d-flex flex-row">
                    <div className="col-md-3 text-center">
                      <img src="/assets/images/H2-testi1.png" alt="" />
                    </div>
                    <div className="col-md-8">
                      <i className="fa-solid fa-star" />
                      <i className="fa-solid fa-star" />
                      <i className="fa-solid fa-star" />
                      <i className="fa-solid fa-star" />
                      <i className="fa-solid fa-star" />
                      <h3 className="card-title">
                        Mst. Shaty khatun <span>Ux Designer</span>
                      </h3>
                    </div>
                  </div>
                  <p>
                    A peso you put in your insurance premium can give you
                    hundreds or thousands of guaranteed benefits. Our experience
                    allows us to be confident and stand by our words.
                  </p>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="card">
                  <div className="card-body d-flex flex-row">
                    <div className="col-md-3 text-center">
                      <img src="/assets/images/H2-testi2.png" alt="" />
                    </div>
                    <div className="col-md-8">
                      <i className="fa-solid fa-star" />
                      <i className="fa-solid fa-star" />
                      <i className="fa-solid fa-star" />
                      <i className="fa-solid fa-star" />
                      <i className="fa-solid fa-star" />
                      <h3 className="card-title">
                        MR Maldonado- <span>Ux Designer</span>
                      </h3>
                    </div>
                  </div>
                  <p>
                    A peso you put in your insurance premium can give you
                    hundreds or thousands of guaranteed benefits. Our experience
                    allows us to be confident and stand by our words.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="carousel-item">
            <div className="row testimonial_carousel">
              <div className="col-lg-6">
                <div className="card">
                  <div className="card-body d-flex flex-row">
                    <div className="col-md-3 text-center">
                      <img src="/assets/images/H2-testi1.png" alt="" />
                    </div>
                    <div className="col-md-8">
                      <i className="fa-solid fa-star" />
                      <i className="fa-solid fa-star" />
                      <i className="fa-solid fa-star" />
                      <i className="fa-solid fa-star" />
                      <i className="fa-solid fa-star" />
                      <h3 className="card-title">
                        Martha Maldonado-<span>Manager</span>
                      </h3>
                    </div>
                  </div>
                  <p>
                    A peso you put in your insurance premium can give you
                    hundreds or thousands of guaranteed benefits. Our experience
                    allows us to be confident and stand by our words.
                  </p>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="card">
                  <div className="card-body d-flex flex-row">
                    <div className="col-md-3 text-center">
                      <img src="/assets/images/H2-testi2.png" alt="" />
                    </div>
                    <div className="col-md-8">
                      <i className="fa-solid fa-star" />
                      <i className="fa-solid fa-star" />
                      <i className="fa-solid fa-star" />
                      <i className="fa-solid fa-star" />
                      <i className="fa-solid fa-star" />
                      <h3 className="card-title">
                        Mst. Shaty khatun <span>Ux Designer</span>
                      </h3>
                    </div>
                  </div>
                  <p>
                    A peso you put in your insurance premium can give you
                    hundreds or thousands of guaranteed benefits. Our experience
                    allows us to be confident and stand by our words.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="carousel-item">
            <div className="row testimonial_carousel">
              <div className="col-lg-6">
                <div className="card">
                  <div className="card-body d-flex flex-row">
                    <div className="col-md-3 text-center">
                      <img src="/assets/images/H2-testi1.png" alt="" />
                    </div>
                    <div className="col-md-8">
                      <i className="fa-solid fa-star" />
                      <i className="fa-solid fa-star" />
                      <i className="fa-solid fa-star" />
                      <i className="fa-solid fa-star" />
                      <i className="fa-solid fa-star" />
                      <h3 className="card-title">
                        MR Maldonado- <span>Ux Designer</span>
                      </h3>
                    </div>
                  </div>
                  <p>
                    A peso you put in your insurance premium can give you
                    hundreds or thousands of guaranteed benefits. Our experience
                    allows us to be confident and stand by our words.
                  </p>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="card">
                  <div className="card-body d-flex flex-row">
                    <div className="col-md-3 text-center">
                      <img src="/assets/images/H2-testi2.png" alt="" />
                    </div>
                    <div className="col-md-8">
                      <i className="fa-solid fa-star" />
                      <i className="fa-solid fa-star" />
                      <i className="fa-solid fa-star" />
                      <i className="fa-solid fa-star" />
                      <i className="fa-solid fa-star" />
                      <h3 className="card-title">
                        Mst. Shaty khatun <span>Ux Designer</span>
                      </h3>
                    </div>
                  </div>
                  <p>
                    A peso you put in your insurance premium can give you
                    hundreds or thousands of guaranteed benefits. Our experience
                    allows us to be confident and stand by our words.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <button
          className="carousel-control-prev"
          type="button"
          data-bs-target="#carouselExampleIndicators"
          data-bs-slide="prev"
        >
          <span className="carousel-control-prev-icon" aria-hidden="true" />
          <span className="visually-hidden">Previous</span>
        </button>
        <button
          className="carousel-control-next"
          type="button"
          data-bs-target="#carouselExampleIndicators"
          data-bs-slide="next"
        >
          <span className="carousel-control-next-icon" aria-hidden="true" />
          <span className="visually-hidden">Next</span>
        </button>
      </div>
      {/* ------------ For Mobile view ------------- */}
      <div
        id="carouselExampleIndicatorsmobile"
        className="carousel slide  d-block d-lg-none"
      >
        <div className="carousel-inner">
          <div className="carousel-item active">
            <div className="row testimonial_carousel">
              <div className="col-lg-12">
                <div className="card">
                  <div className="card-body d-flex flex-row">
                    <div className="col-md-3 text-center">
                      <img src="/assets/images/H2-testi1.png" alt="" />
                    </div>
                    <div className="col-md-8">
                      <i className="fa-solid fa-star" />
                      <i className="fa-solid fa-star" />
                      <i className="fa-solid fa-star" />
                      <i className="fa-solid fa-star" />
                      <i className="fa-solid fa-star" />
                      <h3 className="card-title">
                        Mst. Shaty khatun <span>Ux Designer</span>
                      </h3>
                    </div>
                  </div>
                  <p>
                    A peso you put in your insurance premium can give you
                    hundreds or thousands of guaranteed benefits. Our experience
                    allows us to be confident and stand by our words.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="carousel-item">
            <div className="row testimonial_carousel">
              <div className="col-lg-12">
                <div className="card">
                  <div className="card-body d-flex flex-row">
                    <div className="col-md-3 text-center">
                      <img src="/assets/images/H2-testi2.png" alt="" />
                    </div>
                    <div className="col-md-8">
                      <i className="fa-solid fa-star" />
                      <i className="fa-solid fa-star" />
                      <i className="fa-solid fa-star" />
                      <i className="fa-solid fa-star" />
                      <i className="fa-solid fa-star" />
                      <h3 className="card-title">
                        Mst. Shaty khatun <span>Ux Designer</span>
                      </h3>
                    </div>
                  </div>
                  <p>
                    A peso you put in your insurance premium can give you
                    hundreds or thousands of guaranteed benefits. Our experience
                    allows us to be confident and stand by our words.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="carousel-item">
            <div className="row testimonial_carousel">
              <div className="col-lg-12">
                <div className="card">
                  <div className="card-body d-flex flex-row">
                    <div className="col-md-3 text-center">
                      <img src="/assets/images/H2-testi1.png" alt="" />
                    </div>
                    <div className="col-md-8">
                      <i className="fa-solid fa-star" />
                      <i className="fa-solid fa-star" />
                      <i className="fa-solid fa-star" />
                      <i className="fa-solid fa-star" />
                      <i className="fa-solid fa-star" />
                      <h3 className="card-title">
                        Martha Maldonado-<span>Manager of II it institute</span>
                      </h3>
                    </div>
                  </div>
                  <p>
                    A peso you put in your insurance premium can give you
                    hundreds or thousands of guaranteed benefits. Our experience
                    allows us to be confident and stand by our words.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <button
          className="carousel-control-prev"
          type="button"
          data-bs-target="#carouselExampleIndicatorsmobile"
          data-bs-slide="prev"
        >
          <span className="carousel-control-prev-icon" aria-hidden="true" />
          <span className="visually-hidden">Previous</span>
        </button>
        <button
          className="carousel-control-next"
          type="button"
          data-bs-target="#carouselExampleIndicatorsmobile"
          data-bs-slide="next"
        >
          <span className="carousel-control-next-icon" aria-hidden="true" />
          <span className="visually-hidden">Next</span>
        </button>
      </div>
    </div>
  </div>

  <BlogSections/>
  <Footer/>
        </>
    );
}
export default Testimonial;